import { UploadCloud } from "../icons";

const MiniDropzone = ({
  label,
  accept,
  hint,
  onFile,
  fileName,
  disabled = false,
}) => {
  const id = `drop-${label.replace(/\s/g, "")}`;
  const handleChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    onFile?.(f);
    e.target.value = "";
  };

  return (
    <div className="w-full">
      <span className="flex justify-between">
        <p className="text-xs font-medium text-base-content/70 mb-1">{label}</p>
        <p className="text-xs text-orange-500 flex items-start gap-1">
          <span className="mt-[1px]">⚠</span>
          <span>Assets with similar type will be replaced</span>
        </p>
      </span>

      <div className="bg-base-200/60 rounded-box border-2 border-dashed border-base-content/20">
        <label
          htmlFor={id}
          className="block text-center cursor-pointer p-6 sm:p-8"
        >
          <input
            id={id}
            type="file"
            className="hidden"
            accept={accept}
            onChange={handleChange}
            disabled={disabled}
          />

          {!fileName ? (
            <>
              <div className="flex justify-center mb-2 opacity-70">
                <UploadCloud />
              </div>

              <p className="text-base-content/50 mb-2 text-sm">{hint}</p>

              <span>Drag & Drop to Upload</span>

              <p className="text-base-content/50 my-2 text-xs">or</p>

              <p className="link link-primary font-medium text-sm">Browse</p>
            </>
          ) : (
            <div className="flex items-center justify-between gap-3 rounded-xl border border-base-content/10 bg-base-100 px-3 py-2 shadow-sm">
              <div className="flex items-center gap-3 min-w-0">
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{fileName}</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    onFile?.(null);
                  }}
                  className="shrink-0 text-base-content/50 hover:text-base-content"
                >
                  ✕
                </button>
              </div>
            </div>
          )}
        </label>
      </div>
    </div>
  );
};
export default MiniDropzone;
